<style lang="scss">
.chat-box-wrapper {
  .chat-box {
    width: 350px;
    @include positioningOffset(fixed, unset, 15px, 0, unset);
    z-index: $z-index-top;

    header {
      background-color: $blue-theme;
      color: white;
      border-top-left-radius: 1rem;
      border-top-right-radius: 1rem;
    }

    &__messages {
      height: 365px;
      overflow-y: auto;
      background-color: white;
      scroll-behavior: smooth;

      &__message {
        &.own {
          .msg-text {
            background-color: $blue-theme;
            color: white;
          }

          .chat-box__messages__content {
            margin-left: auto;
          }
        }
      }

      .chat-box__messages__content {
        max-width: 95%;
        padding-bottom: 0 !important;

        .msg-text {
          border-radius: 1rem;

          &.msg-shadow {
            box-shadow: 4px 4px 3px 0 rgba(34, 41, 47, 0.1);
          }
        }

      }
    }

    &__entry {
      background-color: $blue-theme;

      .send-icon {
        padding-left: 5px;
      }
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="chat-box-wrapper hidden-start">
    <div class="chat-box menu-shadow animate__animated animate__faster"
         :class="open ? 'animate__slideInUp' : 'animate__slideOutDown'">
      <header class="p-1 d-flex justify-content-between align-items-baseline">
        Chatting with {{participantName}}
        <p class="mb-0 pl-1 pointer" @click="openChatbox(false)">
          <i  class="fas fa-times"></i>
        </p>
      </header>
      <section class="chat-box__messages pb-1">
        <section class="chat-box__messages__message d-flex" v-for="msg in messages" :class="{'own': msg.name === name}">
          <section class="chat-box__messages__content full-width p-1">
            <p class="msg-text mb-0 msg-shadow p-1">{{ msg.message }}</p>
            <small class="d-inline-block full-width" :class="msg.name === name ? 'text-right' : 'text-left'"
                   v-if="msg.timestamp">{{ msg.timestamp | formatDateTime }}</small>
          </section>
        </section>
      </section>
      <section class="chat-box__entry p-1 d-inline-flex align-items-end full-width">
        <b-form-textarea v-model="entry" @keyup.enter="sendMessage(entry)"
                         placeholder="Enter a message..."></b-form-textarea>
        <p @click="sendMessage(entry)" class="send-icon text-white mb-0 pointer"><i class="fas fa-paper-plane"></i></p>
      </section>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import moment from 'moment';

export default {
  components: {},
  props: {},
  data() {
    return {
      entry: '',
    };
  },
  computed: {
    ...mapState({
      open: state => state.callFeatures.chatbox.open,
      messages: state => state.callFeatures.chatbox.messages,
      name: state => state.callFeatures.name,
      participantName: state => state.callFeatures.participantName,
    }),
  },
  watch: {
    messages: {
      deep: true,
      handler() {
        this.scrollToLatest();
      },
    },
  },
  mounted() {},
  methods: {
    openChatbox(value) {
      this.$store.commit('callFeatures/SET_CHATBOX_OPEN', value);
    },
    sendMessage(message) {
      if (!message) {
        return;
      }
      const msg = message.trim();
      if (msg && msg.length > 0) {
        this.$store.dispatch('callFeatures/addMessage', {
          name: this.name,
          timestamp: moment().toDate(),
          message: msg,
        });
      }
      this.entry = ''; // reset entry
    },
    scrollToLatest() {
      setTimeout(() => {
        const elm = document.querySelector('.chat-box__messages');
        elm.scrollTop = elm.scrollHeight;
      });
    },
  },
};
</script>
